module.exports = __webpack_public_path__ + "img/avtar.b62bb43.jpg";